import React from "react";
import { MdOutlineSend } from "react-icons/md";

const ChatBot = ({ color }) => {
  return (
    <div
      className="w-[23rem] h-[30rem] bg-white border border-[#fb6a2b] rounded-lg p-1 relative"
      style={{ borderColor: color }}
    >
      <div className="flex gap-3 items-center bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b] px-4 py-4 rounded-lg text-white">
        <div>
          <img
            src={require("../../assets/image/user-avatar-icon.png")}
            alt=""
            className="w-[80px] h-[80px] rounded-full"
          />
        </div>
        <div>
          <p className="font-bold text-lg">Chat With </p>
          <p>AI-BOT</p>
        </div>
      </div>
      <div>
        <div className="flex w-full justify-end mt-2 px-3">
          <p className="flex gap-3 items-center bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b] px-2 py-2  w-fit rounded-lg text-white">
            Hey..
          </p>
        </div>
        <div className="flex w-full justify-start mt-2 px-3">
          <p className="flex gap-3 items-center bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b] px-2 py-2  w-fit rounded-lg text-white">
            Hello..
          </p>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 px-2 py-2 flex justify-between items-center w-full">
        <input
          type="text"
          placeholder="type here..."
          className="border p-1 rounded-md px-2 outline-none w-[85%]"
          style={{ borderColor: color }}
        />
        <button className="bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b] px-2 py-2 rounded-full flex items-center justify-center">
          <MdOutlineSend className="text-[1.3rem] text-white" />
        </button>
      </div>
    </div>
  );
};

export default ChatBot;
